var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0013 0.333496C14.9218 0.333496 15.668 1.07969 15.668 2.00016V19.6431L19.4895 15.8217C20.1403 15.1708 21.1956 15.1708 21.8465 15.8217C22.4974 16.4725 22.4974 17.5278 21.8465 18.1787L15.1798 24.8453C14.5289 25.4962 13.4737 25.4962 12.8228 24.8453L6.15612 18.1787C5.50525 17.5278 5.50525 16.4725 6.15612 15.8217C6.807 15.1708 7.86227 15.1708 8.51315 15.8217L12.3346 19.6431V2.00016C12.3346 1.07969 13.0808 0.333496 14.0013 0.333496ZM2.33464 25.3335C3.25511 25.3335 4.0013 26.0797 4.0013 27.0002V30.3335H24.0013V27.0002C24.0013 26.0797 24.7475 25.3335 25.668 25.3335C26.5884 25.3335 27.3346 26.0797 27.3346 27.0002V30.3335C27.3346 32.1744 25.8423 33.6668 24.0013 33.6668H4.0013C2.16035 33.6668 0.667969 32.1744 0.667969 30.3335V27.0002C0.667969 26.0797 1.41416 25.3335 2.33464 25.3335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.266b75707b0706d1573b4f9b1c9ac63f.svg";
export { ForwardRef as ReactComponent };